import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/** Aura with MCC brand primary (#003053) instead of default emerald. */
export const MccPrimeNgPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f2f5f6',
      100: '#c2cdd6',
      200: '#91a6b5',
      300: '#617f94',
      400: '#305774',
      500: '#003053',
      600: '#002947',
      700: '#00223a',
      800: '#001a2e',
      900: '#001321',
      950: '#000a12',
    },
  },
  components: {
    accordion: {
      panel: {
        borderWidth: '1px',
        borderColor: '#dee2e6',
      },
      header: {
        padding: '0.5rem',
        fontWeight: '700',
        fontSize: '14px',
        background: '#e4e4e4',
        hoverBackground: '#ccc',
        activeBackground: '#e4e4e4',
        activeHoverBackground: '#ccc',
        color: '#343a40',
        hoverColor: '#212529',
        activeColor: '#343a40',
        activeHoverColor: '#212529',
        borderRadius: '2px',
        borderWidth: '0',
        first: {
          topBorderRadius: '2px',
          borderWidth: '0',
        },
        last: {
          bottomBorderRadius: '2px',
          activeBottomBorderRadius: '0',
        },
        toggleIcon: {
          color: '#343a40',
          hoverColor: '#212529',
          activeColor: '#343a40',
          activeHoverColor: '#212529',
        },
      },
      content: {
        padding: '0',
        borderWidth: '0',
        background: '#ffffff',
        color: '#495057',
      },
    },
    datatable: {
      headerCell: {
        padding: '0.5rem 0.25rem',
        sm: { padding: '0.5rem 0.25rem' },
      },
      bodyCell: {
        padding: '0.5rem 0.25rem',
        sm: { padding: '0.5rem 0.25rem' },
      },
      columnTitle: {
        fontWeight: '700',
      },
    },
    radiobutton: {
      root: {
        width: '20px',
        height: '20px',
        shadow: 'none',
      },
      icon: {
        size: '10px',
      },
    },
    treeselect: {
      root: {
        background: '#ffffff',
        borderColor: 'rgba(0, 0, 0, 0.38)',
        hoverBorderColor: 'rgba(0, 0, 0, 0.87)',
        focusBorderColor: '#003053',
        placeholderColor: 'rgba(0, 0, 0, 0.6)',
        shadow: 'none',
        paddingX: '0.75rem',
        paddingY: '0.5rem',
        borderRadius: '4px',
        focusRing: {
          width: '0',
          shadow: 'none',
        },
      },
      dropdown: {
        width: '2.357rem',
        color: 'rgba(0, 0, 0, 0.6)',
      },
    },
    multiselect: {
      root: {
        background: '#ffffff',
        borderColor: 'rgba(0, 0, 0, 0.38)',
        hoverBorderColor: 'rgba(0, 0, 0, 0.87)',
        focusBorderColor: '#003053',
        placeholderColor: 'rgba(0, 0, 0, 0.6)',
        shadow: 'none',
        paddingX: '0.75rem',
        paddingY: '0.5rem',
        borderRadius: '4px',
        focusRing: {
          width: '0',
          shadow: 'none',
        },
      },
      dropdown: {
        width: '2.357rem',
        color: 'rgba(0, 0, 0, 0.6)',
      },
    },
  },
  css: `
    .p-accordionpanel {
      margin-bottom: 7px;
      border-radius: 2px;
      overflow-x: auto;
      overflow-y: hidden;
      max-width: 100%;
    }
    .p-accordionheader {
      justify-content: flex-start !important;
      gap: 0.25rem !important;
      font-size: 14px;
      font-weight: 700;
      color: #343a40 !important;
    }
    .p-accordionheader-toggle-icon,
    .p-accordionheader .pi,
    .p-accordionheader .p-icon {
      order: -1;
      margin-right: 0.5rem !important;
    }
    /* Default PrimeNG icons are down (collapsed) / up (open). MCC uses right / down. */
    .p-accordionheader[aria-expanded="false"] svg,
    .p-accordionheader[data-p-active="false"] svg {
      transform: rotate(-90deg);
    }
    .p-accordionheader[aria-expanded="true"] svg,
    .p-accordionheader[data-p-active="true"] svg {
      transform: rotate(180deg);
    }
    .p-accordionheader > *:not(.p-accordionheader-toggle-icon):not(.pi):not(.p-icon) {
      margin-left: 0.5rem;
    }
    .p-accordioncontent,
    .p-accordioncontent-content {
      padding: 0;
      max-width: 100%;
      min-width: 0;
      overflow-x: auto;
    }
    .p-datatable,
    .p-datatable-table-container {
      max-width: 100%;
      overflow-x: auto;
    }
    .p-blockui:not(.p-overlay-mask) {
      display: none;
    }

    p-radiobutton,
    .p-radiobutton {
      width: 20px !important;
      height: 20px !important;
      min-width: 20px !important;
      max-width: 20px !important;
      min-height: 20px !important;
      max-height: 20px !important;
      overflow: hidden !important;
      border-radius: 50% !important;
    }

    .p-radiobutton .p-radiobutton-box,
    .p-radiobutton-box {
      width: 20px !important;
      height: 20px !important;
      min-width: 20px !important;
      max-width: 20px !important;
      min-height: 20px !important;
      max-height: 20px !important;
      border-radius: 50% !important;
    }

    .p-radiobutton input[type="radio"],
    .p-radiobutton-input {
      appearance: none !important;
      -webkit-appearance: none !important;
      min-width: 0 !important;
      max-width: 20px !important;
      width: 20px !important;
      height: 20px !important;
      position: absolute !important;
      opacity: 0 !important;
    }
  `,
});
